import React, { useEffect } from "react";
import AnnouncementData from "../../components/AnnouncementComponent";
import CountData from "../../components/CountComponent";
import ConcernData from "../../components/EmployeeConcernComponent";
import MyToDoData from "../../components/MyToDoComponent";
import SpotlightData from "../../components/SpotlightComponent";
import TabComponent from "../../components/TabComponent";

import '../../components/css/Dashboard-styles.css'


function Activities() {

    // useEffect(() => {

    //     const fetchapi = async () => {

    //         //
    //         const resp = await getCountData()

    //         
    //     }

    //     fetchapi()


    // }, [])


    return (
        // <div className="body-bg">
        //     <div className="container-fluid ">
        //         <div className="row">
        //             <TabComponent />
        <div className="tab-pane" id="pills-profile" role="tabpanel" aria-labelledby="activities-dashboard-tab">
            <div className="d-flex justify-content-between mt-3">
                <CountData />
                {/*Annoucements*/}
                <div className="dashboard-custom-col-40 rounded-5 dashboard-container-background dashboard-annoucement-color-gradient">
                    <AnnouncementData />
                </div>
                {/*Spotlight*/}
                <div className="dashboard-custom-col-25 rounded-5 dashboard-container-background dashboard-spotlight-color-gradient">
                    <SpotlightData />
                </div>
                {/*Spotlight- Ends here */}
            </div>
            <div className=" d-flex justify-content-between mt-3">
                <MyToDoData />
                {/*My Todo - Ends here*/}
                {/*Team Member Concern*/}
                <div className="dashboard-custom-col-30 rounded-5 dashboard-container-background ">
                    <h1 className="tt-bold font-15 p-3">Team Member Concerns</h1>
                    <ConcernData />
                </div>
                {/*Team Member Concerns - Ends here*/}
            </div>
        </div>
        //         </div>
        //     </div>
        // </div>


    )
}


export default Activities;